import "./OurProducts.css";
import SEO from "../SEO/SEO";

import Product1  from "./images/Product1.webp";
import Product2  from "./images/Product2.webp";
import Product3  from "./images/Product3.webp";
import Product4  from "./images/Product4.webp";
import Product5  from "./images/Product5.webp";
import Product6  from "./images/Product6.webp";
import Product7  from "./images/Product7.avif";
import Product8  from "./images/Product8.jpg";
import Product10 from "./images/Product10.webp";
import Product12 from "./images/Product12.webp";
import Product13 from "./images/Product13.webp";
import Product15 from "./images/Product15.webp";
import Product16 from "./images/Product16.webp";
import Product17 from "./images/Product17.webp";
import Product18 from "./images/Product18.jpg";
import Product20 from "./images/Product20.webp";
import Product21 from "./images/Product21.jpg";
import Product23 from "./images/Product23.jpg";
import Product25 from "./images/Product25.jpeg";
import Product26 from "./images/Product26.jpg";
import Product28 from "./images/Product28.webp";
import Product29 from "./images/Product29.jpeg";

const products = [
  { id: 1,  image: Product1  },
  { id: 2,  image: Product2  },
  { id: 3,  image: Product3  },
  { id: 4,  image: Product4  },
  { id: 5,  image: Product5  },
  { id: 6,  image: Product6  },
  { id: 7,  image: Product7  },
  { id: 8,  image: Product8  },
  { id: 10, image: Product10 },
  { id: 12, image: Product12 },
  { id: 13, image: Product13 },
  { id: 15, image: Product15 },
  { id: 16, image: Product16 },
  { id: 17, image: Product17 },
  { id: 18, image: Product18 },
  { id: 20, image: Product20 },
  { id: 21, image: Product21 },
  { id: 23, image: Product23 },
  { id: 25, image: Product25 },
  { id: 26, image: Product26 },
  { id: 28, image: Product28 },
  { id: 29, image: Product29 },
];

export default function Products() {
  return (
    <div className="products-section">
      <SEO path="/products" />
      {/* ── HERO HEADER ── */}
      <div className="products-page-header">
        <span className="products-page-tag">Our Nursery</span>
        <h1 className="products-title">
          Plants & <em>Nursery Collection</em>
        </h1>
        <p className="products-subtitle">
          We supply over <b>500+ plant varieties</b> — exotic species, indoor
          collections, flowering plants, shrubs, trees, and premium pots for
          every space.
        </p>
        <span className="products-page-divider" />
      </div>

      {/* ── GRID ── */}
      <div className="products-grid-wrapper">

        <div className="products-grid-label">
          <h3>Explore Our Collection</h3>
          <p>Hover to preview · Curated for every space</p>
        </div>

        <div className="products-grid">
          {products.map((item) => (
            <div className="product-card" key={item.id}>
              <div className="product-image-wrapper">
                <img
                  src={item.image}
                  className="product-image"
                  alt={`Plant ${item.id}`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── FOOTER STRIP ── */}
      <div className="products-footer">
        <p>✦ Every plant hand-picked for quality, health & beauty ✦</p>
      </div>

    </div>
  );
}